<template>
    <div :class="computedClass">
        {{ formatted[displayField] }}
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    raw: Object,
    formatted: Object,
    label: String,
    displayField: String,
    conditions: Array,
});

const computedClass = computed(() => {
    const { formatted, conditions } = props;

    if (conditions[0]['name'] && conditions[1]['name']) {
        return formatted.raw[conditions[0]['name']] < formatted.raw[conditions[1]['name']]
            ? conditions[0]['class']
            : conditions[1]['class'];
    }
    if (conditions[0]['name'] && conditions[1]['value']) {
        return formatted.raw[conditions[0]['name']] < conditions[1]['value']
            ? conditions[0]['class']
            : conditions[1]['class'];
    }
    if (conditions[0]['value'] && conditions[1]['name']) {
        return conditions[0]['value'] < formatted.raw[conditions[1]['name']]
            ? conditions[1]['class']
            : conditions[0]['class'];
    }
    return ''; // Default return if none of the above conditions match
});
</script>
